module.exports = __webpack_public_path__ + "static/img/yz.a1674ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yz.jpg
// module id = ntrW
// module chunks = 1